import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  authstatus: false,
  data: null,
};

const authslice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.authstatus = true;
      state.data = action.payload;
    },
    logout: (state) => {
      state.authstatus = false;
      state.data = null;
    },
  },
});

export const { login, logout } = authslice.actions;
export default authslice.reducer;
